/**
 * Hotove sablony, ze kterych jde zacit (SPEC-2 kap. 10.6).
 *
 * Definovane na jednom miste, protoze je potrebuje editor v administraci
 * i nahrani demo dat. Obsah vychazi z e-mailu, ktere TicketsGP uz posila.
 */
const CDN = 'https://ticketsgp.vshcdn.net/uploads/images';
const SE_CDN = 'https://cdn-smartemailing.cz/689800/media';
/**
 * Kampan „kalendar je venku, vyber si zavod". Texty jsou z e-mailu, ktery
 * TicketsGP dnes posila; zmenila se jen sazba: hero, mrizka zavodu s terminy,
 * tlacitka a banner partnera.
 */
const motogpCalendar = {
    code: 'M05',
    base: 'JRN_M05_dalsi-rocnik',
    seller: 'TGP',
    language: 'en',
    name: 'MotoGP 2027 — calendar is out',
    label: 'MotoGP — kalendář ročníku (podle vašeho e-mailu)',
    doc: {
        subject: 'MotoGP 2027 calendar is out. Where will you be? 🏁',
        preheader: 'Four races on sale. Pick your circuit and book your weekend.',
        blocks: [
            {
                type: 'hero',
                image: `${SE_CDN}/2026/2023-motogp-japan-02709-1.webp`,
                alt: 'MotoGP 2027',
                href: 'https://www.tickets.gp/en/motogp',
                eyebrow: 'MotoGP experience 2027',
                title: 'Your 2027 MotoGP plans start here',
                html: 'Hello,<br /><br />The 2027 MotoGP calendar is here — and your next race weekend is waiting. Tickets for <b>Sachsenring</b>, the <b>USA</b>, <b>Silverstone</b> and <b>Austria</b> are now on sale, giving you four incredible ways to experience MotoGP live.<br /><br />Choose your circuit, bring your racing crew and get ready for the sound, speed and atmosphere you can only experience trackside.',
                button: { text: 'Pick your race →', url: 'https://www.tickets.gp/en/motogp' },
            },
            { type: 'spacer', size: 'm' },
            {
                type: 'heading',
                level: 2,
                eyebrow: 'Pick your race',
                text: 'Four races. Where will you be?',
                align: 'center',
            },
            {
                type: 'cards',
                columns: 2,
                items: [
                    {
                        image: `${CDN}/12216/detail-motogp-usa.jpg`,
                        alt: 'MotoGP Americas, Circuit of the Americas',
                        title: 'MotoGP Americas',
                        subtitle: '23/04 – 25/04/2027',
                        url: 'https://www.tickets.gp/en/motogp/motogpunitedstates',
                        button: 'Buy now →',
                    },
                    {
                        image: `${CDN}/12212/detail-motogp-sachsenring.jpg`,
                        alt: 'MotoGP Germany, Sachsenring',
                        title: 'MotoGP Germany',
                        subtitle: '09/07 – 11/07/2027',
                        url: 'https://www.tickets.gp/en/motogp/motogpsachsenring',
                        button: 'Buy now →',
                    },
                    {
                        image: `${CDN}/12213/detail-motogp-silverstone.jpg`,
                        alt: 'MotoGP Silverstone',
                        title: 'MotoGP Silverstone',
                        subtitle: '13/08 – 15/08/2027',
                        url: 'https://www.tickets.gp/en/motogp/motogpsilverstone',
                        button: 'Buy now →',
                    },
                    {
                        image: `${CDN}/12195/detail-motogp-austria.jpg`,
                        alt: 'MotoGP Austria, Red Bull Ring',
                        title: 'MotoGP Austria',
                        subtitle: '27/08 – 29/08/2027',
                        url: 'https://www.tickets.gp/en/motogp/motogpaustria',
                        button: 'Buy now →',
                    },
                ],
            },
            { type: 'spacer', size: 'm' },
            {
                type: 'heading',
                level: 2,
                text: 'Give yourself something to count down to',
                align: 'center',
            },
            {
                type: 'text',
                html: 'That first glimpse of the track. The engines firing up. Your favourite rider flying past. Make 2027 the year you’re there to feel it all — choose your race and book your tickets today.',
            },
            {
                type: 'button',
                text: 'Find your MotoGP weekend →',
                url: 'https://www.tickets.gp/en/motogp',
            },
            { type: 'spacer', size: 'm' },
            {
                type: 'image',
                url: `${SE_CDN}/banners/newsgp%20banner-27-1.png`,
                alt: 'NewsGP',
                href: 'https://www.news.gp',
                width: 480,
            },
            { type: 'footer', note: 'See you at the racetrack!<br />TicketsGP team' },
        ],
    },
};
const NAV = {
    type: 'nav',
    brand: 'Tickets',
    brandAccent: 'GP',
    links: [
        { text: 'F1', url: 'https://www.tickets.gp/en/f1' },
        { text: 'MotoGP', url: 'https://www.tickets.gp/en/motogp' },
        { text: 'Vstupenky', url: 'https://www.tickets.gp' },
    ],
};
const FOOTNOTE = {
    type: 'text',
    html: '* Ilustrační ceny. Nabídka a podmínky dle závodu.',
    size: 'small',
    muted: true,
    align: 'center',
};
const FOOTER = {
    type: 'footer',
    compact: true,
    links: [{ text: 'Nastavení odběru', url: 'https://www.tickets.gp' }],
};
const HELP = {
    type: 'callout',
    icon: '🎧',
    title: 'Potřebujete poradit s výběrem?',
    text: 'Jsme tu pro vás.',
    link: { text: 'Kontaktujte nás', url: 'https://www.tickets.gp' },
};
/**
 * Návrh 01 — jeden závod. Celé v HTML a CSS (žádný slepený obrázek): úvodní
 * plocha s textem přes fotku, cenový box, výhody, řádky vstupenek a pruh
 * s výzvou. Fotky jsou zatím z veřejného CDN — u F1 je potřeba doplnit vlastní.
 */
const singleRace = {
    code: 'M01',
    base: 'JRN_M01_planovani',
    seller: 'TGP',
    language: 'cs',
    name: 'Návrh 01 — Jeden závod',
    label: 'Návrh 01 — Jeden závod (Velká cena Rakouska)',
    doc: {
        subject: 'Velká cena Rakouska: vstupenky jsou v prodeji',
        preheader: 'Motory, tribuny a víkend, na který nezapomenete. Vstupenky od 199 €.',
        blocks: [
            NAV,
            {
                type: 'cover',
                image: `${CDN}/12195/detail-motogp-austria.jpg`,
                alt: 'Red Bull Ring',
                badge: 'Prodej zahájen',
                title: 'Zažijte závod naživo.',
                height: 440,
            },
            { type: 'heading', level: 1, text: 'Velká cena Rakouska' },
            { type: 'text', html: 'Red Bull Ring • termín dle kalendáře', muted: true },
            { type: 'text', html: 'Motory, tribuny a víkend, na který nezapomenete.' },
            {
                type: 'pricebox',
                label: 'Víkendové vstupenky',
                price: 'od 199 €*',
                button: { text: 'Vybrat vstupenky →', url: 'https://www.tickets.gp/en/f1' },
            },
            { type: 'heading', level: 2, text: 'Proč vyrazit do Spielbergu?' },
            {
                type: 'features',
                items: [
                    { icon: '🏔️', label: 'Alpská atmosféra' },
                    { icon: '🔭', label: 'Skvělé výhledy' },
                    { icon: '📅', label: 'Celý závodní víkend' },
                ],
            },
            { type: 'heading', level: 2, text: 'Najděte své místo' },
            {
                type: 'offers',
                items: [
                    {
                        image: `${CDN}/12212/detail-motogp-sachsenring.jpg`,
                        alt: 'General Admission — atmosféra u trati',
                        title: 'General Admission',
                        desc: 'Volnost pohybu a atmosféra u trati',
                        price: 'od 199 €*',
                        button: 'Zobrazit možnosti',
                        url: 'https://www.tickets.gp/en/f1',
                    },
                    {
                        image: `${CDN}/12213/detail-motogp-silverstone.jpg`,
                        alt: 'Tribuna — výhled z vyhrazeného místa',
                        title: 'Tribuna',
                        desc: 'Pohodlí a výhled z vyhrazeného místa',
                        price: 'od 349 €*',
                        button: 'Zobrazit možnosti',
                        url: 'https://www.tickets.gp/en/f1',
                    },
                ],
            },
            {
                type: 'cover',
                image: `${CDN}/12216/detail-motogp-usa.jpg`,
                alt: 'Okolí Red Bull Ringu',
                title: 'Spojte závod s víkendem v Rakousku',
                subtitle: 'Tipy na cestu a ubytování',
                button: { text: 'Naplánovat víkend', url: 'https://www.tickets.gp' },
                height: 240,
                size: 'medium',
            },
            HELP,
            {
                type: 'button',
                text: 'Prohlédnout vstupenky →',
                url: 'https://www.tickets.gp/en/f1',
                shape: 'square',
                fullWidth: true,
            },
            FOOTNOTE,
            FOOTER,
        ],
    },
};
/**
 * Návrh 02 — přehled závodů. Fotka vlevo, vpravo série, název, termín, cena
 * a tlačítko; pod tím průvodce výběrem, upozornění na prodej a nabídka pomoci.
 */
const raceOverview = {
    code: 'M05',
    base: 'JRN_M05_dalsi-rocnik',
    seller: 'TGP',
    language: 'cs',
    name: 'Návrh 02 — Přehled závodů',
    label: 'Návrh 02 — Přehled závodů (F1 a MotoGP)',
    doc: {
        subject: 'Kam letos vyrazíte? Vyberte si závodní víkend',
        preheader: 'F1 i MotoGP. Atmosféra, kterou u obrazovky nezažijete.',
        blocks: [
            NAV,
            {
                type: 'cover',
                image: `${SE_CDN}/2026/2023-motogp-japan-02709-1.webp`,
                alt: 'MotoGP — jezdci v zatáčce',
                title: 'Váš další závodní víkend.',
                subtitle: 'Vyberte si F1 nebo MotoGP.',
                height: 400,
            },
            { type: 'heading', level: 1, text: 'Kam letos vyrazíte?' },
            { type: 'text', html: 'Atmosféra, kterou u obrazovky nezažijete.', muted: true },
            {
                type: 'racelist',
                items: [
                    {
                        image: `${CDN}/12195/detail-motogp-austria.jpg`,
                        alt: 'Red Bull Ring',
                        series: 'F1',
                        name: 'Rakousko',
                        meta: 'Termín dle kalendáře • Red Bull Ring',
                        price: 'od 199 €*',
                        button: 'Vybrat vstupenky →',
                        url: 'https://www.tickets.gp/en/f1',
                    },
                    {
                        image: `${CDN}/12212/detail-motogp-sachsenring.jpg`,
                        alt: 'MotoGP Brno',
                        series: 'MotoGP',
                        name: 'Brno',
                        meta: 'Termín dle kalendáře • Masarykův okruh',
                        price: 'od 129 €*',
                        button: 'Vybrat vstupenky →',
                        url: 'https://www.tickets.gp/en/motogp',
                    },
                    {
                        image: `${CDN}/12213/detail-motogp-silverstone.jpg`,
                        alt: 'F1 Barcelona',
                        series: 'F1',
                        name: 'Barcelona',
                        meta: 'Termín dle kalendáře • Barcelona',
                        price: 'od 229 €*',
                        button: 'Vybrat vstupenky →',
                        url: 'https://www.tickets.gp/en/f1',
                    },
                ],
            },
            {
                type: 'cover',
                image: `${CDN}/12216/detail-motogp-usa.jpg`,
                alt: 'Tribuna u trati',
                title: 'Tribuna, nebo přírodní plocha?',
                subtitle: 'Pomůžeme vám vybrat správný typ vstupenky.',
                button: { text: 'Průvodce výběrem', url: 'https://www.tickets.gp' },
                height: 240,
                size: 'medium',
            },
            {
                type: 'callout',
                icon: '🔔',
                title: 'Váš závod ještě není v prodeji?',
                text: 'Nechte si dát vědět, až budou vstupenky dostupné.',
                button: { text: 'Chci upozornění', url: 'https://www.tickets.gp' },
            },
            HELP,
            FOOTNOTE,
            FOOTER,
        ],
    },
};
/** Servisni zprava o stavu cesty — kratka, bez obrazku. */
const tripStatus = {
    code: 'S06',
    base: 'JRN_S06_stav-vstupenek',
    seller: 'TGP',
    language: 'cs',
    name: 'Stav vstupenek',
    label: 'Servisní zpráva — stav cesty',
    doc: {
        subject: '{{race_name}}: jak to vypadá s vašimi vstupenkami',
        preheader: 'Krátká zpráva o stavu vaší cesty.',
        blocks: [
            { type: 'heading', level: 1, text: 'Vaše cesta na {{race_name}}' },
            {
                type: 'text',
                html: 'Dobrý den,<br /><br />tady je aktuální stav vaší cesty. Kdyby cokoli nesedělo, stačí odepsat.',
            },
            { type: 'race', show: ['date', 'place', 'tickets'] },
            { type: 'button', text: 'Otevřít detail cesty', url: 'https://www.tickets.gp' },
            { type: 'footer' },
        ],
    },
};
export const STARTER_TEMPLATES = [
    singleRace,
    raceOverview,
    motogpCalendar,
    tripStatus,
];
export const starterTemplateKey = (t) => `${t.base}_${t.seller}_${t.language}`;
const paymentBlock = (cs) => ({
    type: 'text',
    html: cs
        ? 'Číslo účtu: <b>{{bank_account}}</b><br />Variabilní symbol: <b>{{variable_symbol}}</b><br />Částka: <b>{{payment_amount}}</b><br />Splatnost: <b>{{payment_due_date}}</b>'
        : 'Bank account: <b>{{bank_account}}</b><br />Variable symbol: <b>{{variable_symbol}}</b><br />Amount: <b>{{payment_amount}}</b><br />Due date: <b>{{payment_due_date}}</b>',
});
const orderButton = (cs) => ({
    type: 'button',
    text: cs ? 'Zobrazit objednávku' : 'View your order',
    url: '{{order_url}}',
});
const orderItems = (cs) => ({
    type: 'orderitems',
    heading: cs ? 'Vaše objednávka' : 'Your order',
});
export const TX_STARTERS = {
    T01: {
        cs: {
            subject: 'Objednávka {{order_code}} je zaplacena',
            preheader: 'Děkujeme za platbu, shrnutí najdete v e-mailu.',
            blocks: [
                { type: 'heading', level: 1, text: 'Děkujeme za objednávku {{order_code}}' },
                { type: 'text', html: 'Dobrý den, platbu jsme přijali. Shrnutí objednávky najdete níže.' },
                orderItems(true),
                { type: 'text', html: 'Způsob platby: {{payment_method}}.', size: 'small', muted: true },
                orderButton(true),
            ],
        },
        en: {
            subject: 'Order {{order_code}} is paid',
            preheader: 'Thank you for your payment, the summary is below.',
            blocks: [
                { type: 'heading', level: 1, text: 'Thank you for order {{order_code}}' },
                {
                    type: 'text',
                    html: 'Hello, we have received your payment. Your order summary is below.',
                },
                orderItems(false),
                { type: 'text', html: 'Payment method: {{payment_method}}.', size: 'small', muted: true },
                orderButton(false),
            ],
        },
    },
    T02: {
        cs: {
            subject: 'Objednávka {{order_code}} čeká na platbu',
            preheader: 'Zaplaťte prosím převodem, údaje najdete v e-mailu.',
            blocks: [
                { type: 'heading', level: 1, text: 'Objednávka {{order_code}} čeká na platbu' },
                {
                    type: 'text',
                    html: 'Dobrý den, děkujeme za objednávku. Zaplaťte ji prosím převodem na účet.',
                },
                paymentBlock(true),
                orderItems(true),
                orderButton(true),
            ],
        },
        en: {
            subject: 'Order {{order_code}} is waiting for payment',
            preheader: 'Please pay by bank transfer, the details are below.',
            blocks: [
                { type: 'heading', level: 1, text: 'Order {{order_code}} is waiting for payment' },
                { type: 'text', html: 'Hello, thank you for your order. Please pay it by bank transfer.' },
                paymentBlock(false),
                orderItems(false),
                orderButton(false),
            ],
        },
    },
    T03: {
        cs: {
            subject: 'Upomínka: objednávka {{order_code}} není zaplacena',
            preheader: 'Platba k objednávce zatím nedorazila.',
            blocks: [
                { type: 'heading', level: 1, text: 'Objednávka {{order_code}} zatím není zaplacena' },
                {
                    type: 'text',
                    html: 'Dobrý den, platba k objednávce zatím nedorazila. Pokud jste ji už poslali, tento e-mail prosím ignorujte.',
                },
                paymentBlock(true),
                orderButton(true),
            ],
        },
        en: {
            subject: 'Reminder: order {{order_code}} is not paid',
            preheader: 'We have not received the payment yet.',
            blocks: [
                { type: 'heading', level: 1, text: 'Order {{order_code}} is not paid yet' },
                {
                    type: 'text',
                    html: 'Hello, we have not received the payment yet. If you have already paid, please ignore this email.',
                },
                paymentBlock(false),
                orderButton(false),
            ],
        },
    },
    T04: {
        cs: {
            subject: 'Vstupenky k objednávce {{order_code}} jsou odeslány',
            preheader: 'Vaše objednávka byla odeslána.',
            blocks: [
                { type: 'heading', level: 1, text: 'Objednávka {{order_code}} je odeslána' },
                { type: 'text', html: 'Dobrý den, vstupenky k vaší objednávce jsme odeslali.' },
                orderItems(true),
                orderButton(true),
            ],
        },
        en: {
            subject: 'Tickets for order {{order_code}} have been dispatched',
            preheader: 'Your order has been dispatched.',
            blocks: [
                { type: 'heading', level: 1, text: 'Order {{order_code}} has been dispatched' },
                { type: 'text', html: 'Hello, the tickets for your order have been dispatched.' },
                orderItems(false),
                orderButton(false),
            ],
        },
    },
    T06: {
        cs: {
            subject: 'Odpověď zákaznické podpory',
            blocks: [
                { type: 'heading', level: 2, text: 'Odpověď na váš dotaz' },
                { type: 'text', html: '{{reply_text}}', preserveLines: true },
            ],
        },
        en: {
            subject: 'Reply from customer support',
            blocks: [
                { type: 'heading', level: 2, text: 'Reply to your message' },
                { type: 'text', html: '{{reply_text}}', preserveLines: true },
            ],
        },
    },
    T07: {
        cs: {
            subject: 'Přijali jsme váš dotaz',
            preheader: 'Ozveme se vám co nejdříve.',
            blocks: [
                { type: 'heading', level: 1, text: 'Přijali jsme váš dotaz' },
                {
                    type: 'text',
                    html: 'Dobrý den, váš dotaz jsme přijali a ozveme se vám co nejdříve. Zpráva, kterou jste nám poslali:',
                },
                { type: 'text', html: '{{form_message}}', preserveLines: true, muted: true },
            ],
        },
        en: {
            subject: 'We have received your message',
            preheader: 'We will get back to you as soon as possible.',
            blocks: [
                { type: 'heading', level: 1, text: 'We have received your message' },
                {
                    type: 'text',
                    html: 'Hello, we have received your message and will get back to you soon. This is what you sent us:',
                },
                { type: 'text', html: '{{form_message}}', preserveLines: true, muted: true },
            ],
        },
    },
};
//# sourceMappingURL=starter-templates.js.map